export const faqs = [
  {
    question: "17c每日大赛是完全免费的吗？",
    answer: "是的！17c每日大赛对所有用户完全免费开放。你可以免费注册、免费参赛、免费赢取奖励。我们通过赞助商合作和平台广告来维持运营，绝不会向参赛者收取任何费用。部分高级赛事可能需要达到一定等级才能参加，但等级提升同样是免费的。",
  },
  {
    question: "每天可以参加几场赛事？",
    answer: "17c每日大赛每天会开放多场不同类型的赛事，你可以根据自己的时间和兴趣自由选择参赛。一般来说，每位用户每天最多可以参加10场正式赛事。我们建议每天选择2-3场最适合自己的赛事认真参与，这样既能获得不错的积分，又不会占用太多时间。",
  },
  {
    question: "获得的奖励如何领取？",
    answer: "实物奖品：我们会在赛事结束后的3个工作日内通过站内信确认收货地址，7个工作日内安排发货。虚拟奖励：赛事结束后即时发放到你的账户。现金红包：通过绑定的支付方式发放，通常24小时内到账。所有奖励领取记录都可以在个人中心的「奖励记录」中查看。",
  },
  {
    question: "如何提升我的参赛排名？",
    answer: "提升排名的方法包括：每天保持参赛连续性（连续参赛有额外加分）、选择自己擅长的赛事类型获取更高表现分、参加限时高积分赛事、邀请好友参赛获得邀请奖励、关注平台活动期间的双倍积分机会。最重要的是找到适合自己的赛事类型，持续稳定地参与。",
  },
  {
    question: "团队赛最少需要几个人？",
    answer: "不同团队赛事的要求不同。一般来说，小型团队赛最少需要2人，标准团队赛需要3-5人，大型团队赛可能需要5-8人。具体的参赛人数要求会在每场赛事的规则说明中明确标注。如果找不到足够的队友，可以在社区频道发布招募信息。",
  },
  {
    question: "如果错过了今天的赛事怎么办？",
    answer: "别担心！17c每日大赛的核心理念就是「错过今天还有明天」。每天都会有全新的赛事开放，你不会因为错过一天而落后太多。我们建议开启赛事提醒功能，这样就不会错过重要的赛事通知。此外，每周和每月的累计排名会考虑你的整体表现，偶尔缺席一天影响不大。",
  },
  {
    question: "平台支持哪些设备参赛？",
    answer: "17c每日大赛支持多种设备：您可以通过网页版（PC/Mac浏览器）、手机App（iOS和Android）、以及平板设备参赛。不同赛事可能对设备有不同要求，竞技类赛事建议使用PC以获得更好的操作体验，休闲类赛事在手机上就能轻松参与。",
  },
  {
    question: "如何确保赛事的公平性？",
    answer: "公平公正是17c每日大赛的核心原则。我们采用多重机制保障公平：AI反作弊系统实时监控异常行为、人工审核团队处理争议判罚、赛事回放功能支持玩家申诉、匿名举报通道保护举报者隐私。一旦确认违规行为，将根据情节严重程度给予警告、扣分、禁赛等处罚。",
  },
];